import { render, staticRenderFns } from "./EditableField.vue?vue&type=template&id=d39bfd8e&scoped=true&"
import script from "./EditableField.vue?vue&type=script&lang=js&"
export * from "./EditableField.vue?vue&type=script&lang=js&"
import style0 from "./EditableField.vue?vue&type=style&index=0&id=d39bfd8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39bfd8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d39bfd8e')) {
      api.createRecord('d39bfd8e', component.options)
    } else {
      api.reload('d39bfd8e', component.options)
    }
    module.hot.accept("./EditableField.vue?vue&type=template&id=d39bfd8e&scoped=true&", function () {
      api.rerender('d39bfd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fleet-management/EditableField.vue"
export default component.exports